export interface AppMenuItem {
  label: string;
  icon: string;
  route?: string;
  exact?: boolean;
  children?: AppMenuItem[];
}

export interface AppBreadcrumbItem {
  label: string;
  route?: string;
  filter?:boolean;
}

export const APP_MENU: AppMenuItem[] = [
  { label: 'NPC Dashboard', icon: 'pi-th-large', route: '/npc-dashboard', exact: true },
  { label: 'RPC Dashboard', icon: 'pi-th-large', route: '/rpc-dashboard', exact: true },
  { label: 'Account Process', icon: 'pi-sync', route: '/account-process', exact: true },
  { label: 'Report Center', icon: 'pi-chart-bar', route: '/report-center', exact: true },
  {
    label: 'Ticketing Portal',
    icon: 'pi-ticket',
    children: [
      { label: 'Ticket Dashboard', icon: 'pi-chart-pie', route: '/tickets/dashboard', exact: true },
      { label: 'Raise Ticket', icon: 'pi-send', route: '/tickets/raise', exact: true },
    ],
  },
  {
    label: 'User Management',
    icon: 'pi-users',
    route: '/user-management/list',
    children: [
      { label: 'User Registration', icon: 'pi-user-plus', route: '/user-management/register', exact: true },
      { label: 'User List', icon: 'pi-list', route: '/user-management/list', exact: true },
    ],
  },
  { label: 'Audit Log', icon: 'pi-history', route: '/audit-log', exact: true },
];

export const ROUTE_BREADCRUMBS: Record<string, AppBreadcrumbItem[]> = {
  '/npc-dashboard': [{ label: 'NPC Dashboard',filter:true }],
  '/rpc-dashboard': [{ label: 'RPC Dashboard',filter:true }],
  '/account-process': [
    { label: 'Account Process' },
  ],
  '/account-process/details': [
    { label: 'Account Process', route: '/account-process' },
    { label: 'Process Details' },
  ],
  '/report-center': [{ label: 'Report Center' }],
  '/dsa': [{ label: 'DSA' }],
  '/tickets/dashboard': [
    { label: 'Ticket Dashboard' },
  ],
  '/tickets/raise': [
    { label: 'Ticket Dashboard', route: '/tickets/dashboard' },
    { label: 'Raise Ticket' },
  ],
  '/user-management/list': [
    { label: 'User Management' },
    { label: 'User List' },
  ],
  '/user-management/register': [
    { label: 'User Management' },
    { label: 'User Registration' },
  ],
  '/user-management/view': [
    { label: 'User Management' },
    { label: 'View User' },
  ],
  '/user-management/edit': [
    { label: 'User Management' },
    { label: 'Edit User' },
  ],
  '/audit-log': [
    { label: 'Audit Log' },
  ],
};
